// extracted by css-extract-rspack-plugin
export default {"titleContainer":"title-container--mslxYOmaag06a1dI"};